/* eslint-disable no-unused-vars */
import moment, { Moment } from 'moment';

import { ObligationFile } from '../../../operations/file/types';
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirstLetter';
import { getTagBackgroundColor, getTagIcon } from '../helpers';
import { Container, TagStyled, TimeLine, TimeLineItem } from '../styles';

type Props = {
  selectedDate: Moment;
  files: ObligationFile[];
  openDrawer: (file: ObligationFile) => void;
};

export const MobileFiles = ({ selectedDate, files, openDrawer }: Props) => {
  const getStatusName = (file: ObligationFile) => {
    if (moment(file.due_at).isBefore(moment(), 'dates') && !file.viewed_at) {
      return 'VENCIDO';
    }
    if (file.viewed_at) {
      return 'BAIXADO';
    }

    return 'NÃO BAIXADO';
  };

  return (
    <Container>
      <TimeLine>
        {files
          .sort((a, b) => moment(a.due_at).diff(b.due_at))
          .map((item) => (
            <TimeLineItem key={item.id} onClick={() => openDrawer(item)}>
              <span>{`${moment(item.due_at).date()} ${capitalizeFirstLetter(
                moment(item.due_at).format('MMM')
              )}`}</span>
              <span>{item.description}</span>
              <TagStyled $color={getTagBackgroundColor(item)}>
                {getTagIcon(item)}
                {getStatusName(item)}
              </TagStyled>
            </TimeLineItem>
          ))}
      </TimeLine>
    </Container>
  );
};
